// extracted by mini-css-extract-plugin
export default {"container":"Result_container__DE7HE","resultButtons":"Result_resultButtons__FlLAF"};